const E2E_MARKER_KEY = "nexus_e2e";

/**
 * True when Playwright has marked this browser session as E2E traffic — set
 * via `context.addInitScript()` in `frontend/web/e2e/fixtures.ts`, which runs
 * before any app script on the page. Used only to suppress client
 * analytics/telemetry (Amplitude, Sentry) for test sessions; never for
 * feature gating or access control.
 */
export function isE2ESession(): boolean {
  try {
    return window.localStorage.getItem(E2E_MARKER_KEY) === "1";
  } catch {
    // localStorage can throw in restrictive contexts (e.g. private browsing) — treat as non-E2E.
    return false;
  }
}
